import React, { useContext, useEffect, useState } from 'react';
import { APIDelete, APIGet, APIPost } from '../../../API';
import MeContext from '../../../MeContext';
import { AddUser } from './AddUser';
import { ActiveUsers } from './ActiveUsers';
import { PendingUsers } from './PendingUsers';
import { RenderIf } from '../../../helpers/RenderIf';
import { AlertModal } from '../../../c/Modals';
import { T, TraksConsumer } from '../../../traks';
import { Loading } from '../../../c/Loading';
import { EditUser } from './EditUser';
import UsersContext, { useUsersContext } from '../../../contexts/usersContext';
import { ContentHeader } from '../DashboardPage';
import { Modal } from 'reactstrap';
import DashboardContext from '../../../contexts/dashboardContext';

const DeleteUserModal = ({ isShowing, hide, onConfirm, ...props }) => {
	const confirmText = {
		header: props.render_static(<T>Do you want to delete the user?</T>),
		body: props.render_static(<T>Are you sure you want to delete the user? This action cannot be undone.</T>)
	}

	return (
		<Modal isOpen={isShowing} toggle={hide}>
			<div className="d-flex flex-column px-5 py-4">
				<div onClick={() => hide()} className="fs-5 cursor_pointer text-end">
					x
				</div>
				<div className="text-align-center text-center">
					<div className="tmt-5 mb-3">
						<img src="https://static.sibilus.eu/gfx/alert-circle-icon-0.svg" alt="alert-icon" />
					</div>
					<div className="fw_600 fs-5 mb-4">
						{confirmText.header}
					</div>
					<div className="fs-5">
						{confirmText.body}
					</div>
					<div className="d-flex my-4 w-100">
						<div className="me-3 w-100" style={{ flex: 1 }}>
							<button onClick={hide} className="btn sibilus_border w-100 hoverable-grey">
								<T>Cancel</T>
							</button>
						</div>
						<div className="w-100" style={{ flex: 1 }}>
							<button onClick={onConfirm} className="w-100 btn btn_red white_text">
								<T>Delete</T>
							</button>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	)
}

const Users = ({ users, setUsers, meta, setMeta, ...props }) => {
	const [showAddUser, setShowAddUser] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [showAlert, setShowAlert] = useState(false)
	const [selectedUserId, setSelectedUserId] = useState(undefined)
	const [confirmationModal, setConfirmationModal] = useState(false)
	const [modalText, setModalText] = useState({ type: "success", text: "user deleted" })
	const { me } = useContext(MeContext);
	const { company_id } = me
	const { setActiveTab, updateData, setUpdateData } = useContext(DashboardContext)
	const userRoles = (me && me.roles) || [];
	const useUsers = useUsersContext()

	const getUsers = () => {
		setShowLoading(true)
		APIGet('users', { company_id: company_id }).then((res) => {
			setShowLoading(false)
			const { users, meta, company_settings } = res.data
			setUsers(users);
			setMeta({ ...meta, ...company_settings });
		}).catch(err => {
			setShowLoading(false)
			console.log(err)
			alert("an error has happened")
		});
	};
	const saveUserSettings = (newSettings) => {
		setShowLoading(true)
		const resource = "users/" + newSettings.user_id
		delete newSettings.status
		const body = { user_settings: newSettings, company_id: me.company_id }
		APIPost(resource, body).then(res => {
			setShowLoading(false)
			setModalText({ type: "success", text: "user updated" })
			setShowAlert(true)
			getUsers()
		}).catch(err => {
			setShowLoading(false)
			setModalText({ type: "error", text: err.response.data })
			setShowAlert(true)
			console.log(err)
		})
	}
	const deleteUser = (userId = null) => {
		if (userId) {
			setSelectedUserId(userId)
		}
		setConfirmationModal(!confirmationModal)
		if (confirmationModal) {
			setShowLoading(true)
			APIDelete("users/" + selectedUserId).then(res => {
				getUsers()
			}).catch(error => {
				setShowLoading(false)
				setModalText({ type: "error", text: error.response.data })
				setShowAlert(true)
			})
		}
	}
	const resendInvite = (userId) => {
		APIPost("users/" + userId + "/resendinvite").then(res => {
			setModalText({ type: "success", text: res.data.msg })
			setShowAlert(true)
		}).catch(err => {
			setModalText({ type: "error", text: err.response.data })
			setShowAlert(true)
		})
	}

	useEffect(() => {
		if (!userRoles.includes("company_administrator")) {
			setActiveTab("Whistles")
		} else {
			getUsers()
			setUpdateData(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [me, updateData])

	if (!users || users === undefined || !userRoles.includes("company_administrator")) {
		return (<>
			<Loading
				showLoading={showLoading}
				inFront
			/>
		</>)
	}

	return (
		<>
			<UsersContext.Provider value={useUsers}>
				<div>
					<ContentHeader>
						<div className="d-flex justify-content-between align-items-center">
							<div><T>Users</T></div>
							<button className="btn btn_green bb" onClick={() => setShowAddUser(!showAddUser)}>
								<img className="me-2" src="https://static.sibilus.eu/gfx/add-user-button-0.svg" alt="addUser-icon" style={{ width: "25px" }} />
								<T>Add user</T>
							</button>
						</div >
					</ContentHeader>
					<RenderIf condition={users !== undefined}>
						<div>
							<PendingUsers
								users={users}
								deleteUser={deleteUser}
								resendInvite={resendInvite}
							/>
							<ActiveUsers
								users={users}
								deleteUser={deleteUser}
							/>
							<EditUser
								saveUserSettings={saveUserSettings}
								meta={meta}
							/>
							<AddUser
								showAddUser={showAddUser}
								setShowAddUser={setShowAddUser}
								meta={meta}
							/>
						</div>
					</RenderIf>
				</div>
			</UsersContext.Provider>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={modalText.type}
				text={modalText.text}
			/>
			<TraksConsumer>
				<DeleteUserModal
					isShowing={confirmationModal}
					hide={() => setConfirmationModal(false)}
					onConfirm={deleteUser}
				/>
			</TraksConsumer>
			<Loading
				showLoading={showLoading}
				inFront
				overlay
			/>

		</>)
};
export default Users;
